









































import Vue from "@/shim-vue";
import { Component, Prop, Emit, Watch, VModel } from "vue-property-decorator";

import config from "@/config/dialog";

import popup from "../popup";

@Component({
    name: "LoniDialog",
    components: {
        popup
    }
})
export default class LoniDialog extends Vue {
    /** 消息弹窗是否可见 */
    @VModel({ type: Boolean, required: true })
    private visibleValue!: boolean;

    /** 标题 */
    @Prop()
    public title?: string;

    /** 消息内容 */
    @Prop()
    public message?: string;

    /** 是否显示取消按钮 */
    @Prop({ type: Boolean, default: undefined })
    public showCancelButton?: boolean;

    /** 是否显示确认按钮 */
    @Prop({ type: Boolean, default: undefined })
    public showConfirmButton?: boolean;

    /** 确认按钮文字内容 */
    @Prop()
    public confirmButtonText?: string;

    /** 确认按钮文字颜色 */
    @Prop()
    public confirmButtonColor?: string;

    /** 取消按钮文字内容 */
    @Prop()
    public cancelButtonText?: string;

    /** 取消按钮文字颜色 */
    @Prop()
    public cancelButtonColor?: string;

    /** 点击弹窗背景区域是否关闭弹窗 */
    @Prop({ type: Boolean, default: undefined })
    public closeOnClickOverlay?: boolean;

    /** 是否在页面切换时自动关闭 */
    @Prop({ type: Boolean, default: undefined })
    public closeOnPopstate?: boolean;

    /** 点击事件是否带.once修饰符(这是实例化调用时会用到的一个参数，正常使用中一般不会需要用到) */
    @Prop({ type: Boolean, default: undefined })
    public eventOnce?: boolean;

    public visible = false;
    private get visibleTrans() {
        return this.visible;
    }
    private set visibleTrans(value) {
        this.$emit("input", value);
        this.visible = this.visibleValue;
    }

    public get options() {
        return {
            title: this.title ?? config.title,
            confirmButtonText: this.confirmButtonText ?? config.confirmButtonText,
            confirmButtonColor: this.confirmButtonColor ?? config.confirmButtonColor,
            showConfirmButton: this.showConfirmButton ?? config.showConfirmButton,
            cancelButtonText: this.cancelButtonText ?? config.cancelButtonText,
            cancelButtonColor: this.cancelButtonColor ?? config.cancelButtonColor,
            showCancelButton: this.showCancelButton ?? config.showCancelButton,
            closeOnClickOverlay: this.closeOnClickOverlay ?? config.closeOnClickOverlay,
            closeOnPopstate: this.closeOnPopstate ?? config.closeOnPopstate
        }
    }

    @Watch("visibleValue")
    private onVisibleChanged() {
        this.visibleTrans = this.visibleValue;
    }

    @Emit()
    private confirm() {
        this.visibleTrans = false;
    }

    @Emit()
    private cancel() {
        this.visibleTrans = false;
    }
}
